@if (!showSpinner$$() || _hasRows$$()) {
    <ng-container *ngTemplateOutlet="template$$()"></ng-container>
}
@if (showSpinner$$()) {
    <div class="loading-overlay" [class.loading-overlay--over]="_hasRows$$()"><div class="spinner"></div></div>
}

<ng-template #template_footer>
    <app-tablist-footer
        (onFilterChange)="emit_onFilterChange()"
    ></app-tablist-footer>
</ng-template>

<ng-template #template_buttons>
    @if (!loadingPage$$() && !buttonsHide$$()) {
        @if (mainListShow$$()) {
            <div class="button-row" [@showHide]>
                @if (btnAddShow$$()) {
                    <app-button-action
                        (btnClick)="emit_btnAdd_click()"
                        [tooltip]="'add to list'"
                    >
                        <app-icon name="plus" />
                    </app-button-action>
                }
                @if (btnDeletedListShow$$() && hasDeletedList$$()) {
                    <app-button-action
                        (btnClick)="emit_toggleDeleted()"
                        [tooltip]="'deleted from list'"
                    >
                        <app-icon name="deleted-list" />
                    </app-button-action>
                }
                @if (btnDeletedListShow$$() && hasInactiveList$$()) {
                    <app-button-action
                        (btnClick)="emit_toggleDeleted(_tabModeInactive)"
                        [tooltip]="'inactive list'"
                    >
                        inactive
                    </app-button-action>
                }
            </div>
        } @else {
            <div class="button-row" [@showHide]>
                <app-button-action
                    (btnClick)="emit_toggleDeleted()"
                    [tooltip]="'cancel'"
                >
                    <app-icon name="xmark" />
                </app-button-action>
                @if (deletedListShow$$() && btnRestoreListShow$$()) {
                    <app-button-action
                        (btnClick)="emit_btnRestore_click()"
                        [tooltip]="'restore selection'"
                        [disabled]="btnRestoreDisabled$$()"
                    >
                        restore
                    </app-button-action>
                }
                @if (deletedListShow$$() && btnDeleteDeepShow$$()) {
                    <app-button-action
                        (btnClick)="emit_btnDeleteDeep_click()"
                        [tooltip]="'delete selection permanently'"
                        [disabled]="btnDeleteDeepDisabled$$()"
                    >
                        delete
                    </app-button-action>
                }
                @if (inactiveListShow$$()) {
                    <app-button-action
                        (btnClick)="emit_btnRestore_click()"
                        [tooltip]="'restore selection'"
                        [disabled]="btnRestoreDisabled$$()"
                    >
                        restore
                    </app-button-action>
                }
            </div>
        }
    }
</ng-template>
